<template>
    <div>
        <block v-if="loading"></block>
        <div>
            <v-row>
                <v-col cols="12" md="6" class="">
                    <v-radio-group v-model="search.typeData"  class="ma-3">
                        <v-radio label="Ver reporte con datos de prueba" value="00"></v-radio>
                        <v-radio label="Ver reporte con datos de producción" value="01"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>

            <v-row class="mx-2 pt-5">
                <v-col cols="12" md="4" lg="2">
                    <v-checkbox v-model="showTwoDate" @change="handleDateModeChange" label="Intervalo de fechas"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="2" class="d-flex justify-right" v-if="showTwoDate === false">
                    <date-picker label="Fecha de solicitud" @dateSelected="setDateFilter" class="mx-5" />
                </v-col>
                <v-col cols="12" md="4" lg="2" class="d-flex justify-right" v-if="showTwoDate === true">
                    <date-picker label="Desde" @dateSelected="setDateFilterFrom" />
                </v-col>
                <v-col cols="12" md="4" lg="2" class="d-flex justify-right" v-if="showTwoDate === true">
                    <date-picker label="Hasta" @dateSelected="setDateFilterTo" />
                </v-col>
                <v-col cols="12" md="4" :lg="showTwoDate === false ? 3: 2">
                    <v-select 
                        outlined
                        dense
                        v-model="search.branch"
                        :items="branches"
                        :item-text="getBranchLabel"
                        attach
                        item-value="ID_Branch"
                        label="Sucursal"
                    >
                    </v-select>
                </v-col>
                <v-col cols="12" md="4" :lg="showTwoDate === false ? 3: 2">
                    <v-checkbox v-model="search.showOnlyDebit" label="Mostrar solo comprobantes con saldo"></v-checkbox>
                </v-col>
                <v-col cols="12" md="4" lg="2" class="d-flex justify-end">
                    <v-btn class="btn-save" @click="setupPrint" :disabled="!SummaryData || SummaryData.length == 0">
                        <v-icon>mdi-printer</v-icon>
                    </v-btn>
                </v-col>
            </v-row>
            
            <VersatileFilter 
                :columnsSearch.sync="columsConfig" 
                :search="search" 
                :columnfilterEndpoint="getAccountsReceivableSummaryByDate"
                :filterEndpoint="getAccountsReceivableSummaryByDate"
                :isAutoScrolled="true"
                :hideLimitLabel="true"
                advancedFilter
                @emptyFilter="getAccountsPaymentHistory" 
                @filtered="filterHandler"
                disableDates
                class="pt-3" 
                style="padding: 1rem;"
                v-if="!showEvery30Days"
            >

                <template v-slot:complementFilters>
                    <div class="d-flex align-center pt-5">
                        <v-row class="mx-2">
                            <v-col cols="12" md="4">
                                <v-checkbox v-model="showEvery30Days" @change="getData" label="Utilizar intervalos de 30 días"></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-checkbox v-model="groupReportByCustomer" label="Agrupar por cliente y mostrar subtotales"></v-checkbox>
                            </v-col>
                        </v-row>
                    </div>
                </template>
                <DxDataGrid  
                    :dataSource="SummaryData"
                    :showBorders="true"
                    ref="dataGrid"
                    @exporting="onExporting"
                    :scrolling="{ useNative: true }"
                    :paging="{ enabled: false }"
                    :column-auto-width="true" 
                    style="max-height: 600px;"
                    @option-changed="onOptionChanged"
                >
                    <DxExport :enabled="true" />
                    <DxScrolling mode="virtual"/>
                    <DxLoadPanel :enabled="true"/>

                    <DxColumn
                        dataField="ID_Customer"
                        caption="CLIENTE"
                        :visible="false"
                        :group-index="groupReportByCustomer ? 0 : undefined"
                        group-cell-template="customer-group-template"
                    />
                    <DxColumn dataField="LegalName" caption="NOMBRE CLIENTE"></DxColumn>
                    <DxColumn dataField="AdditionalInformation" :caption="additionalInformationTitle"></DxColumn>
                    <DxColumn caption="Clase" cell-template="show-template-class"></DxColumn>
                    <DxColumn caption="Categoría" cell-template="show-template-category"></DxColumn>
                    <DxColumn caption="Subcategoría" cell-template="show-template-subcategory"></DxColumn>
                    <DxColumn 
                        dataField="ID_Branch" 
                        caption="Sucursal" 
                        :calculateDisplayValue="branch => getBranchLabel(branch)" 
                    />
                    <DxColumn dataField="SellerName" caption="VENDEDOR"></DxColumn>
                    <DxColumn dataField="ZoneClient" caption="ZONA"></DxColumn>
                    <DxColumn :width="150" dataField="InvoiceType" caption="TIPO DOCUMENTO"></DxColumn>
                    <DxColumn :width="350" dataField="ID_Invoice" caption="NÚMERO INTERNO"></DxColumn>
                    <DxColumn :width="350" dataField="CodigoGeneracion" caption="CÓDIGO DE GENERACIÓN"></DxColumn>
                    <DxColumn :width="300" dataField="NumeroControl" caption="NÚMERO DE CONTROL"></DxColumn>
                    <DxColumn :width="150" dataField="InvoiceDateToShow" caption="FECHA"></DxColumn>
                    <DxColumn :width="150" dataField="ExpirationDateToShow" caption="VENCE"></DxColumn>
                    <DxColumn :width="100" dataField="Days" caption="DIAS"></DxColumn>
                    <DxColumn dataField="Charges" caption="MONTO" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Payments" caption="ABONO" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Balance" caption="SALDO" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Balance_0_to_45_Days" caption="0 - 45 DÍAS" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Balance_46_to_70_Days" caption="46 - 70 DÍAS" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Balance_71_to_90_Days" caption="70 - 90 DÍAS" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Balance_91_to_150_Days" caption="91 - 150 DÍAS" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Over151" caption="MÁS DE 150 DÍAS" :customize-text="formatGridAmount"></DxColumn>
                    <DxSummary v-if="groupReportByCustomer">
                        <DxGroupItem column="ID_Customer" show-in-column="LegalName" summary-type="count" :show-in-group-footer="true" :customize-text="subtotalGridLabel" />
                        <DxGroupItem v-for="field in summaryFields45" :key="`group-${field}`" :column="field" summary-type="sum" :show-in-group-footer="true" :align-by-column="true" :customize-text="formatGridAmount" display-format="{0}" />
                        <DxTotalItem column="ID_Customer" show-in-column="LegalName" summary-type="count" :customize-text="totalGridLabel" />
                        <DxTotalItem v-for="field in summaryFields45" :key="`total-${field}`" :column="field" summary-type="sum" :customize-text="formatGridAmount" display-format="{0}" />
                    </DxSummary>
                    <template #customer-group-template="{ data }">
                        <strong>{{ getCustomerGroupName(data) }}</strong>
                    </template>
                    <template #show-template-class="{ data }">
                        <div>{{ showClass(data.data.id_class) }}</div>
                    </template>
                    <template #show-template-category="{ data }">
                        <div>{{ showCategories(data.data.id_category) }}</div>
                    </template>
                    <template #show-template-subcategory="{ data }">
                        <div>{{ showSubs(data.data.id_subcategory) }}</div>
                    </template>
                </DxDataGrid>
            </VersatileFilter>

            <VersatileFilter 
                :columnsSearch.sync="columsConfig" 
                :search="search" 
                :columnfilterEndpoint="getAccountsReceivableSummaryByDate"
                :filterEndpoint="getAccountsReceivableSummaryByDate"
                :isAutoScrolled="true"
                :hideLimitLabel="true"
                advancedFilter
                @emptyFilter="getAccountsPaymentHistory" 
                @filtered="filterHandler"
                style="padding: 1rem;"
                v-if="showEvery30Days"
            >
                <template v-slot:complementFilters>
                    <div class="d-flex align-center pt-5">
                        <v-row class="mx-2">
                            <v-col cols="12" md="4">
                                <v-checkbox v-model="showEvery30Days" @change="getData" label="Utilizar intervalos de 30 días"></v-checkbox>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-checkbox v-model="groupReportByCustomer" label="Agrupar por cliente y mostrar subtotales"></v-checkbox>
                            </v-col>
                        </v-row>
                    </div>
                </template>
                <DxDataGrid  
                    :dataSource="DataTable"
                    :showBorders="true"
                    ref="dataGrid2"
                    @exporting="onExporting"
                    :scrolling="{ useNative: true }"
                    :paging="{ enabled: false }"
                    :column-auto-width="true" 
                    style="max-height: 600px;"
                    @option-changed="onOptionChanged"
                >
                    <DxExport :enabled="true" />
                    <DxScrolling mode="virtual"/>
                    <DxLoadPanel :enabled="true"/>

                    <DxColumn
                        dataField="ID_Customer"
                        caption="CLIENTE"
                        :visible="false"
                        :group-index="groupReportByCustomer ? 0 : undefined"
                        group-cell-template="customer-group-template"
                    />
                    <DxColumn dataField="LegalName" caption="NOMBRE CLIENTE"></DxColumn>
                    <DxColumn dataField="AdditionalInformation" :caption="additionalInformationTitle"></DxColumn>
                    <DxColumn caption="Clase" cell-template="show-template-class"></DxColumn>
                    <DxColumn caption="Categoría" cell-template="show-template-category"></DxColumn>
                    <DxColumn caption="Subcategoría" cell-template="show-template-subcategory"></DxColumn>
                    <DxColumn 
                        dataField="ID_Branch" 
                        caption="Sucursal" 
                        :calculateDisplayValue="branch => getBranchLabel(branch)" 
                    />
                    <DxColumn dataField="SellerName" caption="VENDEDOR"></DxColumn>
                    <DxColumn dataField="ZoneClient" caption="ZONA"></DxColumn>
                    <DxColumn :width="150" dataField="InvoiceType" caption="TIPO DOCUMENTO"></DxColumn>
                    <DxColumn :width="350" dataField="ID_Invoice" caption="NÚMERO INTERNO"></DxColumn>
                    <DxColumn :width="350" dataField="CodigoGeneracion" caption="CÓDIGO DE GENERACIÓN"></DxColumn>
                    <DxColumn :width="300" dataField="NumeroControl" caption="NÚMERO DE CONTROL"></DxColumn>
                    <DxColumn :width="150" dataField="InvoiceDateToShow" caption="FECHA"></DxColumn>
                    <DxColumn :width="150" dataField="ExpirationDateToShow" caption="VENCE"></DxColumn>
                    <DxColumn :width="100" dataField="Days" caption="DIAS"></DxColumn>
                    <DxColumn dataField="Charges" caption="MONTO" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Payments" caption="ABONO" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Balance" caption="SALDO" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Balance_0_to_30_Days" caption="0 - 30 DÍAS" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Balance_31_to_60_Days" caption="31 - 60 DÍAS" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Balance_61_to_90_Days" caption="61 - 90 DÍAS" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Balance_91_to_120_Days" caption="91 - 120 DÍAS" :customize-text="formatGridAmount"></DxColumn>
                    <DxColumn dataField="Over121" caption="MÁS DE 121 DÍAS" :customize-text="formatGridAmount"></DxColumn>
                    <DxSummary v-if="groupReportByCustomer">
                        <DxGroupItem column="ID_Customer" show-in-column="LegalName" summary-type="count" :show-in-group-footer="true" :customize-text="subtotalGridLabel" />
                        <DxGroupItem v-for="field in summaryFields30" :key="`group-${field}`" :column="field" summary-type="sum" :show-in-group-footer="true" :align-by-column="true" :customize-text="formatGridAmount" display-format="{0}" />
                        <DxTotalItem column="ID_Customer" show-in-column="LegalName" summary-type="count" :customize-text="totalGridLabel" />
                        <DxTotalItem v-for="field in summaryFields30" :key="`total-${field}`" :column="field" summary-type="sum" :customize-text="formatGridAmount" display-format="{0}" />
                    </DxSummary>
                    <template #customer-group-template="{ data }">
                        <strong>{{ getCustomerGroupName(data) }}</strong>
                    </template>
                    <template #show-template-class="{ data }">
                        <div>{{ showClass(data.data.id_class) }}</div>
                    </template>
                    <template #show-template-category="{ data }">
                        <div>{{ showCategories(data.data.id_category) }}</div>
                    </template>
                    <template #show-template-subcategory="{ data }">
                        <div>{{ showSubs(data.data.id_subcategory) }}</div>
                    </template>
                </DxDataGrid>
            </VersatileFilter>
        </div>

        <div>
            <component v-for="(item, index) in PrintList" :key="index" :is="item.component" v-bind="item.props" />
        </div>
    </div>
</template>

<script>
import VersatileFilter from "@/components/VersatileFilter";
import PrintResumeAccountsReceivableClient from "@/components/ReportsAndPrintings/AccountigReports/PrintResumeAccountsReceivableClient";
import PrintResumeAccountsReceivableClient2 from "@/components/ReportsAndPrintings/AccountigReports/PrintResumeAccountsReceivableClient2";
import { printToExcel } from "@/helpers/printToexcel";
import { DxDataGrid, DxColumn, DxExport, DxScrolling, DxLoadPanel, DxSummary, DxGroupItem, DxTotalItem } from 'devextreme-vue/data-grid'
import DatePicker from '@/components/DatePicker'
import Block from "@/components/Block";

export default {
    name: "SummaryAccountsReceivable",
    components: {
        DatePicker,
        Block,
        DxDataGrid,
        DxColumn,
        DxExport,
        DxScrolling,
        DxLoadPanel,
        DxSummary,
        DxGroupItem,
        DxTotalItem,
        VersatileFilter,
    },
    props: ['win'],
    data() {
        const additionalInformationTitle = Number(JSON.parse(localStorage.getItem("user") || "{}").IsOptical) === 1
            ? "Lugar de trabajo"
            : "Información adicional";
        return {
            additionalInformationTitle,
            loading: false,
            showTwoDate: false,
            search: {
                typeData: "01",
                branch: 0,
                showOnlyDebit: true,
                dateFilterFrom: null,
                dateFilterTo: null,
                requestdate: null,
            },
            SummaryData: [],
            DataTable: [],
            Currency: JSON.parse(localStorage.getItem('branch')).Currency || "",
            branches: [],
            columsConfig: [
                {
                    name: "LegalName",
                    title: "NOMBRE CLIENTE",
                    value: "",
                    type: "text",
                },
                {
                    name: "ID_Invoice",
                    title: "NÚMERO INTERNO",
                    value: "",
                    type: "text",
                },
                {
                    name: "CodigoGeneracion",
                    title: "CÓDIGO DE GENERACIÓN",
                    value: "",
                    type: "text",
                },
                {
                    name: "id_class",
                    title: "Clase",
                    value: "",
                    type: "select",
                    options: [],
                    onChange: this.getCategoriesByClass,
                },
                {
                    name: "id_category",
                    title: "Categoría",
                    value: "",
                    type: "select",
                    options: [],
                    onChange: this.getSubsByCategory,
                    disabled: true,
                },
                {
                    name: "id_subcategory",
                    title: "Subategoría",
                    value: "",
                    type: "select",
                    options: [],
                    disabled: true,
                },
                {
                    name: "AdditionalInformation",
                    title: additionalInformationTitle,
                    value: "",
                    type: "text",
                },
            ],
            dateFilter: null,
            dateFilterFrom: null,
            dateFilterTo: null,
            showEvery30Days: false,
            groupReportByCustomer: false,
            summaryFields45: [
                'Charges',
                'Payments',
                'Balance',
                'Balance_0_to_45_Days',
                'Balance_46_to_70_Days',
                'Balance_71_to_90_Days',
                'Balance_91_to_150_Days',
                'Over151',
            ],
            summaryFields30: [
                'Charges',
                'Payments',
                'Balance',
                'Balance_0_to_30_Days',
                'Balance_31_to_60_Days',
                'Balance_61_to_90_Days',
                'Balance_91_to_120_Days',
                'Over121',
            ],
            Reloadfilter: 0,
            orderTable: null,
            PrintList: [],
            print: {
                show: false,
                header: {
                },
                data: [],
            },
        }
    },
    async mounted() {
        await this.getBranches();
        this.getReportByDate();
        this.getClasses();
        this.getCategories();
        this.getSubs();
    },
    methods: {
        setDateFilterFrom(param) {
            this.dateFilterFrom = param;
            this.search.dateFilterFrom = param;
            this.search.requestdate = this.formatDateString();
        },
        setDateFilterTo(param) {
            this.dateFilterTo = param;
            this.search.dateFilterTo = param;
            this.search.requestdate = this.formatDateString();
        },
        setDateFilter(param) {
            this.dateFilter = param;
            this.search.requestdate = this.formatDateString(param);
        },
        handleDateModeChange(showTwoDate) {
            if (showTwoDate) {
                this.search.requestdate = this.formatDateString();
                return;
            }

            this.dateFilterFrom = null;
            this.dateFilterTo = null;
            this.search.dateFilterFrom = null;
            this.search.dateFilterTo = null;
            this.search.requestdate = this.formatDateString(this.dateFilter);
        },
        getAccountsReceivableSummaryByDate(params = {}) {
            const requestParams = {
                ...params,
                requestBranch: params.requestBranch ?? (parseInt(this.search.branch) || 0),
                envtype: params.envtype ?? this.search.typeData,
                showOnlyDebit: params.showOnlyDebit ?? this.search.showOnlyDebit,
                showEvery30Days: params.showEvery30Days ?? this.showEvery30Days,
            };

            if (this.showTwoDate) {
                requestParams.dateFilterFrom = this.formatDateString(this.dateFilterFrom);
                requestParams.dateFilterTo = this.formatDateString(this.dateFilterTo);
                requestParams.requestdate = this.formatDateString();
            } else {
                requestParams.requestdate = this.formatDateString(this.dateFilter);
            }

            const search = typeof requestParams.search === 'string'
                ? JSON.parse(requestParams.search)
                : { ...(requestParams.search || {}) };
            search.requestdate = requestParams.requestdate;
            search.dateFilterFrom = this.showTwoDate ? this.dateFilterFrom : null;
            search.dateFilterTo = this.showTwoDate ? this.dateFilterTo : null;
            requestParams.search = JSON.stringify(search);

            return this.$API.customers.getsAccountsReceivableSummaryV2(requestParams);
        },
        async setupPrint(){
            const { businessid = "", } = JSON.parse(localStorage.getItem("user"));
            this.business = await this.$API.business.FindOne(businessid)
            this.print.header.title = "Resumen de cuentas por cobrar";
            
            const date = new Date();

            this.print.header.business = this.business;
            //date wiht format dd/mm/yyyy
            this.print.header.cutDate = date.getDate() + "/" + (date.getMonth() + 1) + "/" + date.getFullYear();
            // console.log('this.print', this.print);

            this.print.show = true;
            if (this.showEvery30Days) {
                const rows = this.orderTable ? this.orderPrint(this.DataTable) : this.DataTable.slice();
                this.print.data.body = this.groupReportByCustomer ? this.buildGroupedReportRows(rows, true) : rows;
                // console.log('this.print', this.print);
                this.PrintList.push({component: PrintResumeAccountsReceivableClient2, props: {
                    dataProps: this.print,
                }}); 
            } else {
                const rows = this.orderTable ? this.orderPrint(this.SummaryData) : this.SummaryData.slice();
                this.print.data.body = this.groupReportByCustomer ? this.buildGroupedReportRows(rows, false) : rows;
                this.PrintList.push({component: PrintResumeAccountsReceivableClient, props: {
                    dataProps: this.print,
                }}); 
            }
        },
        orderPrint(dataTable) {
            return dataTable.slice().sort((a, b) => {
                if (typeof a[this.orderTable.campo] === 'string') {
                    if (this.orderTable.direccion === 'asc') {
                        return a[this.orderTable.campo].localeCompare(b[this.orderTable.campo]);
                    }
                    if (this.orderTable.direccion === 'desc') {
                        return b[this.orderTable.campo].localeCompare(a[this.orderTable.campo]);
                    }
                }
                if (typeof a[this.orderTable.campo] === 'number') {
                    if (this.orderTable.direccion === 'asc') {
                        return a[this.orderTable.campo] - b[this.orderTable.campo];
                    }
                    if (this.orderTable.direccion === 'desc') {
                        return b[this.orderTable.campo] - a[this.orderTable.campo];
                    }
                }
            })
        },
        buildGroupedReportRows(rows, every30Days) {
            const fields = every30Days ? [
                ['Charges', 'ChargesFormatted'],
                ['Payments', 'PaymentsFormatted'],
                ['Balance', 'BalanceFormatted'],
                ['Balance_0_to_30_Days', 'Balance_0_to_30_DaysFormatted'],
                ['Balance_31_to_60_Days', 'Balance_31_to_60_DaysFormatted'],
                ['Balance_61_to_90_Days', 'Balance_61_to_90_DaysFormatted'],
                ['Balance_91_to_120_Days', 'Balance_91_to_120_DaysFormatted'],
                ['Over121', 'Over121Formatted'],
            ] : [
                ['Charges', 'ChargesFormatted'],
                ['Payments', 'PaymentsFormatted'],
                ['Balance', 'BalanceFormatted'],
                ['Balance_0_to_45_Days', 'Balance_0_to_45_DaysFormatted'],
                ['Balance_46_to_70_Days', 'Balance_46_to_70_DaysFormatted'],
                ['Balance_71_to_90_Days', 'Balance_71_to_90_DaysFormatted'],
                ['Balance_91_to_150_Days', 'Balance_91_to_150_DaysFormatted'],
                ['Over151', 'Over151Formatted'],
            ];
            const grouped = new Map();
            rows.forEach(row => {
                const key = row.ID_Customer ?? row.LegalName ?? '';
                if (!grouped.has(key)) grouped.set(key, []);
                grouped.get(key).push(row);
            });
            const result = [];
            const grandTotal = this.createReportTotals(fields);
            [...grouped.values()]
                .sort((a, b) => (a[0].LegalName || '').localeCompare(b[0].LegalName || ''))
                .forEach(customerRows => {
                    const subtotal = this.createReportTotals(fields);
                    customerRows.forEach(row => {
                        result.push(row);
                        fields.forEach(([numericField]) => {
                            const value = Number(row[numericField]);
                            subtotal[numericField] += Number.isFinite(value) ? value : 0;
                            grandTotal[numericField] += Number.isFinite(value) ? value : 0;
                        });
                    });
                    result.push(this.createReportTotalRow('subtotal', `SUBTOTAL ${customerRows[0].LegalName || ''}`, subtotal, fields));
                });
            if (result.length) result.push(this.createReportTotalRow('grand-total', 'TOTAL GENERAL', grandTotal, fields));
            return result;
        },
        createReportTotals(fields) {
            return fields.reduce((totals, [numericField]) => {
                totals[numericField] = 0;
                return totals;
            }, {});
        },
        createReportTotalRow(rowType, label, totals, fields) {
            const row = { reportRowType: rowType, LegalName: label };
            fields.forEach(([numericField, formattedField]) => {
                row[numericField] = totals[numericField];
                row[formattedField] = this.formatReportAmount(totals[numericField]);
            });
            return row;
        },
        formatReportAmount(value) {
            return `${this.Currency}${Number(value || 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
        },
        formatGridAmount({ value }) {
            return this.formatReportAmount(value);
        },
        subtotalGridLabel() {
            return 'SUBTOTAL';
        },
        totalGridLabel() {
            return 'TOTAL GENERAL';
        },
        getCustomerGroupName(groupData) {
            const rows = this.showEvery30Days ? this.DataTable : this.SummaryData;
            const firstGroupRow = groupData?.data?.items?.[0] || groupData?.items?.[0];
            const customerId = groupData?.value
                ?? groupData?.key
                ?? groupData?.data?.key
                ?? firstGroupRow?.ID_Customer;
            const customer = firstGroupRow || rows.find(row => String(row.ID_Customer) === String(customerId));
            return customer?.LegalName || String(customerId ?? 'CLIENTE SIN NOMBRE');
        },
        normalizeReportRows(rows) {
            const numericFields = [...new Set([...this.summaryFields45, ...this.summaryFields30])];
            return (rows || []).map(row => {
                const normalized = { ...row };
                numericFields.forEach(field => {
                    const value = Number(row[field]);
                    normalized[field] = Number.isFinite(value) ? value : 0;
                });
                return normalized;
            });
        },
        onExporting(e) {
            printToExcel(e, "Resumen de Cuentas por Cobrar");
        },
        async getData(e){
            if (e === false) {
                return this.getReportByDate();
            }
            this.loading = true;
            
            try {
                let params = { 
                    requestBranch: parseInt(this.search.branch) || 0, 
                    envtype: this.search.typeData,
                    showOnlyDebit: this.search.showOnlyDebit,
                    showEvery30Days: this.showEvery30Days,
                }
                if (this.showTwoDate) {
                    params.dateFilterFrom= this.formatDateString(this.dateFilterFrom);
                    params.dateFilterTo= this.formatDateString(this.dateFilterTo);
                    params.requestdate= this.formatDateString();
                } else {
                    params.requestdate= this.formatDateString(this.dateFilter);
                }   
                    
                const response = await this.$API.customers.getsAccountsReceivableSummaryV2(params);
                if(response.length > 0){
                    // console.log('response', response);
                    this.DataTable = this.normalizeReportRows(response);
                }
                else{
                    this.DataTable = [];
                }
            } catch (error) {
                console.log(error);
                this.showAlert('danger', 'Error', error);
            } finally {
                this.loading = false;
            }
        },
        async getReportByDate() {
            if (this.showEvery30Days) {
                return this.getData();
            }
            try {
                this.loading = true
    
                let params = { 
                    requestBranch: parseInt(this.search.branch) || 0, 
                    envtype: this.search.typeData,
                    showOnlyDebit: this.search.showOnlyDebit,
                    showEvery30Days: this.showEvery30Days,
                }
                if (this.showTwoDate) {
                    params.dateFilterFrom= this.formatDateString(this.dateFilterFrom);
                    params.dateFilterTo= this.formatDateString(this.dateFilterTo);
                    params.requestdate= this.formatDateString();
                } else {
                    params.requestdate= this.formatDateString(this.dateFilter);
                }
                
                const response = await this.$API.customers.getsAccountsReceivableSummaryV2(params);
                this.SummaryData = this.normalizeReportRows(response);
            } catch (error) {
                alert(error)
            } finally {
                this.loading = false
            }
        },
        formatDateString(dateString) {
            if (!dateString) {
                const today = new Date();
                const year = today.getFullYear();
                const month = String(today.getMonth() + 1).padStart(2, '0');
                const day = String(today.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }

            const [day, month, year] = dateString.split('/');
            return `${year}-${month}-${day}`;
        },
        async getBranches() {
            await this.$API.branches
                .findBranches(JSON.parse(localStorage.getItem("user")).businessid)
                .then((data) => {
                    this.branches = [
                        {
                            BranchName: 'Todas',
                            ID_Branch: 0,
                        },
                        ...data
                    ];
                    this.search.branch = data[0].ID_Branch;
                })
                .catch((err) => {
                console.log(err);
                });
        },
        getBranchLabel(branch) {
            if (!branch || branch.BranchName == null) {
                return '';
            }
            if (branch.ID_Branch === 'all') {
                return branch.BranchName
            } else {
                return `${branch.BranchName}`
            }
        },
        onOptionChanged(e) {
            const gridInstance = this.showEvery30Days ? this.$refs.dataGrid2.instance : this.$refs.dataGrid.instance;
  
            const columns = gridInstance.getVisibleColumns();

            const [sorted] = columns
                .filter(c => c.sortOrder)
                .map(c => ({
                campo: c.dataField,
                direccion: c.sortOrder,
                prioridad: c.sortIndex
                }));

            if (typeof e.value === 'string') {
                this.orderTable = sorted
            }
        },
        async filterHandler(response) {
            console.log('response', response);
            if (this.showEvery30Days) {
                this.DataTable = this.normalizeReportRows(response);
            } else {
                this.SummaryData = this.normalizeReportRows(response);
            }
        },
        async getAccountsPaymentHistory(response) {
            console.log('response', response);
            // this.providers = response;
            // await this.getAllAccounts(response);
        },
        getClasses() {
            this.$API.customersTypes.getClasses().then((response) => {
                this.columsConfig[3].options = response.map(element => ({name: element.name, value: element.id}));
            });
        },
        getCategories() {
            this.$API.customersTypes.getCategories().then((response) => {
                this.columsConfig[4].options = response.map(element => ({name: element.name, value: element.id}));
                this.categoriesAll = response;
            });
        },
        getSubs() {
            this.$API.customersTypes.getSubs().then((response) => {
                this.columsConfig[5].options = response.map(element => ({name: element.name, value: element.id}));
                this.subcategoriesAll = response;
            });
        },
        getCategoriesByClass() {
            delete this.columsConfig[4].value;
            delete this.columsConfig[5].value;
            this.columsConfig[4].options = this.categoriesAll.filter(element => element.id_class === this.columsConfig[3].value).map(element => ({name: element.name, value: element.id}));
            this.columsConfig[4].disabled = false;
            this.columsConfig[5].disabled = true;
        },
        getSubsByCategory() {
            delete this.columsConfig[5].value;
            this.columsConfig[5].options = this.subcategoriesAll.filter(element => element.id_cat === this.columsConfig[4].value).map(element => ({name: element.name, value: element.id}));
            this.columsConfig[5].disabled = false;
        },
        showClass(idClass) {
            const classData = this.columsConfig[3].options.find(element => element.value === idClass);
            return classData?.name ?? '';
        },
        showCategories(idCategory) {
            const categoryData = this.categoriesAll.find(element => element.id === idCategory);
            return categoryData?.name ?? '';
        },
        showSubs(idSubcategory) {
            const subcategoryData = this.subcategoriesAll.find(element => element.id === idSubcategory);
            return subcategoryData?.name ?? '';
        },
    }
}
</script>
